module.exports = __webpack_public_path__ + "img/galvindo.c247930e.png";